import { getKnownPlatforms, normalizePlatformName } from "./platformCatalog";

export const INIT_COMPLETE_PREFERENCES = {
  platforms: [],
  buyInMin: "",
  buyInMax: "",
  onboardingCompletedAt: null,
  hasSavedPreferences: false,
};

export const normalizeCompletePreferences = (preferences = {}) => ({
  platforms: Array.isArray(preferences.platforms)
    ? [...new Set(preferences.platforms.map(normalizePlatformName).filter(Boolean))]
    : [],
  buyInMin:
    preferences.buyInMin == null ? String(preferences.abiMin || "") : String(preferences.buyInMin),
  buyInMax:
    preferences.buyInMax == null ? String(preferences.abiMax || "") : String(preferences.buyInMax),
  onboardingCompletedAt: preferences.onboardingCompletedAt || null,
  hasSavedPreferences: Boolean(preferences.hasSavedPreferences),
});

const parseOptionalNumber = (value) => {
  if (value === "" || value == null) return null;
  const parsed = Number(String(value).replace(",", "."));
  return Number.isFinite(parsed) ? parsed : null;
};

export const isValidBuyInPreferenceRange = (preferences = {}) => {
  const normalized = normalizeCompletePreferences(preferences);
  const buyInMin = parseOptionalNumber(normalized.buyInMin);
  const buyInMax = parseOptionalNumber(normalized.buyInMax);

  return buyInMin == null || buyInMax == null || buyInMin <= buyInMax;
};

export const hasCompletePreferenceValues = (preferences = {}) => {
  const normalized = normalizeCompletePreferences(preferences);
  return Boolean(
    normalized.hasSavedPreferences ||
      normalized.onboardingCompletedAt ||
      normalized.platforms.length ||
      normalized.buyInMin ||
      normalized.buyInMax
  );
};

export const getAvailableRegistroPlatforms = (tournaments, currentPlatform = "") =>
  getKnownPlatforms(tournaments, currentPlatform);

export const getSelectedRegistroPlatforms = (
  preferences,
  availablePlatforms
) => {
  const normalized = normalizeCompletePreferences(preferences);
  const available = new Set(availablePlatforms);
  const selected = normalized.platforms.filter((platform) => available.has(platform));

  return selected.length ? selected : availablePlatforms;
};

export const toggleRegistroPlatformPreference = (
  preferences,
  platform,
  availablePlatforms
) => {
  const normalizedPlatform = normalizePlatformName(platform);
  if (!normalizedPlatform) return normalizeCompletePreferences(preferences);

  const selected = getSelectedRegistroPlatforms(preferences, availablePlatforms);
  const isSelected = selected.includes(normalizedPlatform);
  const nextPlatforms = isSelected
    ? selected.filter((item) => item !== normalizedPlatform)
    : [...selected, normalizedPlatform];

  return normalizeCompletePreferences({
    ...preferences,
    platforms: nextPlatforms.length ? nextPlatforms : selected,
  });
};

export const filterTournamentsByPlatformPreferences = (
  tournaments,
  preferences,
  currentPlatform = ""
) => {
  const normalized = normalizeCompletePreferences(preferences);
  const availablePlatforms = getAvailableRegistroPlatforms(tournaments, currentPlatform);
  const selectedPlatforms = new Set(
    getSelectedRegistroPlatforms(normalized, availablePlatforms)
  );
  const buyInMin = parseOptionalNumber(normalized.buyInMin);
  const buyInMax = parseOptionalNumber(normalized.buyInMax);

  return tournaments.filter((tournament) => {
    const buyIn = parseOptionalNumber(tournament?.buyin);
    if (!selectedPlatforms.has(normalizePlatformName(tournament?.plataforma))) {
      return false;
    }
    if (buyInMin != null && (buyIn == null || buyIn < buyInMin)) return false;
    if (buyInMax != null && (buyIn == null || buyIn > buyInMax)) return false;
    return true;
  });
};
